import { getUserById, updateUser, deleteUser, changePwd } from '../api/users.service.js'
import AuthStore from './auth.store.js'

export default {
  state:{
    user: {},
    users: []
  },
  getters:{
    getUser(state){
      return state.user
    },
  },
  mutations: {
    setUser(state, user){
      state.user = user
    }
  },
  actions: {
    setUser(context){
      let user = AuthStore.getters.getCurrentUser()
      context.commit('setUser', user)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/user.store.js